var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$temAcessoView('CTRLACS-APP-04'))?_c('b-button',{staticClass:"mr-2",attrs:{"variant":"secondary"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmar()}}},[_c('span',[_c('i',{staticClass:"fa fa-refresh mr-2"}),_vm._v(" Recriar Token")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }